<template>
	<div>
		<!--编辑 -->
		<el-dialog :title="isEdit?'编辑菜单':'新增菜单'" :visible.sync="dialog" @close="unShowClick()" width="30%">
			<el-form ref="addBody" :rules="rules" :model="addBody">
				<el-form-item label="上级菜单" prop="" :label-width="formLabelWidth">
					<el-select style="width: 350px;" v-model="addBody.pid" placeholder="请选择上级菜单">
						<el-option v-for="item in addBody.level==3?levList:lmList" :key="item.uuid" :label="item.name"
							:value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="菜单名称" prop="name" :label-width="formLabelWidth" v-if="activeName == 'zh'">
					<el-input style="width: 350px;" v-model="addBody.name" placeholder="请输入1-30位菜单名称"></el-input>
				</el-form-item>
				<el-form-item label="路径" :label-width="formLabelWidth" prop="url">
					<el-input style="width: 350px;" v-model="addBody.url" placeholder="请输入路径"></el-input>
				</el-form-item>
				<el-form-item label="权重" prop="weight" :label-width="formLabelWidth" v-if="activeName == 'zh'">
					<el-input style="width: 350px;" v-model="addBody.weight" placeholder="请输入权重，数值越大越靠前"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="unShowClick()">取 消</el-button>
				<el-button type="primary" @click="editUser('addBody')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getAdminMenu,
		addAdminMenu,
		updateAdminMenu,
		getAdminUserDetail
	} from '@/api/auth'
	import ImageUpload from "@/components/ImageUpload"

	export default {
		props: {
			uuid: {
				type: Object,
				default: {},
			},
			value: {
				type: Boolean,
				default: false,
			},
			dialogProp: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			ImageUpload
		},
		data() {
			return {
				activeName: 'zh',
				readid: '',
				dialog: false,
				identTable: [],
				formLabelWidth: '120px',
				isAddAdmin: true,
				addBody: {
					pid: '',
					name: '',
					level: 1,
					url: "",
					p_name: '',
					uuid: '',
					weight:''
				},
				images: [],
				roleUuid: "",
				rules: {
					name: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}, ],
					url: [{
						required: true,
						message: '请输入路径',
						trigger: 'blur'
					}, ],
					p_name: [{
						required: true,
						message: '请输入组件',
						trigger: 'blur'
					}, ],
					weight: [{
						required: true,
						message: '请输入权重',
						trigger: 'blur'
					}, ],
				},
				weightList: [],
				weight: '',
				isEdit: false,
				lmList: [],
				levList: []
			}
		},
		mounted() {

		},
		methods: {
			async getAdminMenu() {
				let postData = {
					page_size: 99,
					page_index: 1,
				};
				const {
					status,
					data
				} = await getAdminMenu(postData);
				if (status !== 200) return;
				this.lmList = data.result.data;
				this.lmList.forEach(item => {
					item.child.forEach(_item=>{
						this.levList.push(_item)
					})
				})
			},
			validatep_name(p_name) {
				const lengthValid = p_name.length >= 8;
				const hasUpperCase = /[A-Z]/.test(p_name);
				const hasLowerCase = /[a-z]/.test(p_name);
				const hasNumber = /\d/.test(p_name);
				const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(p_name);
				const criteriaMet = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length >= 2;
				return lengthValid && criteriaMet;
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			editUser(formName) {
				// if (!this.validatep_name(this.addBody.p_name)) {
				// 	return this.$message.error('密码8位数以上，包含数字、大小写字母、特殊符号任意两种组合')
				// }
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.isEdit) {
							this.network().editUser()
						} else {
							this.network().addAdminMenu()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.$emit('input', false)
			},
			network() {
				return {
					addAdminMenu: async () => {
						if (this.addBody.pid) {
							this.addBody.level = 2
						}
						const {
							status,
							data
						} = await addAdminMenu({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('新增成功')
					},
					editUser: async () => {
						if (this.addBody.pid) {
							this.addBody.level = 2
						}
						const {
							status
						} = await updateAdminMenu({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
					},
					getAdminUserDetail: async (uuid) => {
						const {
							data,
							status
						} = await getAdminUserDetail({
							uuid: uuid
						})
						if (status !== 200) return
						this.addBody = data.result
					},
				}
			},
		},

		watch: {
			uuid(val) {
				if (val.uuid) {
					this.isEdit = true;
					this.addBody.pid = val.pid
					this.addBody.name = val.name
					this.addBody.url = val.url
					this.addBody.p_name = val.p_name
					this.addBody.uuid = val.uuid
					this.addBody.level = val.level
					this.addBody.weight = val.weight
				} else {
					this.isEdit = false
					this.addBody.pid = ''
					this.addBody.name = ''
					this.addBody.url = ''
					this.addBody.p_name = ''
					this.addBody.uuid = ''
					this.addBody.weight = ''
				}
				this.getAdminMenu()
			},
			value(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.dialog = newVal

					this.network().GoodsWeight()
				}
			},
			dialogProp(old) {
				this.dialog = old;
			},
		},
	};
</script>

<style scoped>
</style>